import { Component, Input, Output, EventEmitter } from '@angular/core';
import { STATUSES } from './tracking-page-item.constants';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  TrackingPageCard,
  TrackingPageButton
} from '../../tracking-page.model';
import { isEqual, omit } from 'lodash';
import { STATUS_TEXTS } from '../../constants';
import { copyTextToClipboard } from '../../../../helpers/copy-link';
import { TrackingPageOrderItemsFrame } from '../../tracking-page.model';

@Component({
  selector: 'app-tracking-page-item',
  templateUrl: './tracking-page-item.component.html'
})
export class TrackingPageItemComponent {
  @Input() number: any;
  @Input() open: boolean;
  @Input() checkpointsLoading: boolean;
  @Input() card: TrackingPageCard;
  @Input() orderItemsFrame: TrackingPageOrderItemsFrame;
  @Input() detailsButton: TrackingPageButton;
  @Input() reviewEnabled: boolean;
  @Input() selectedId: any;
  @Input() checkpoints: any;
  @Output() toggleDetails = new EventEmitter();
  @Output() showFeedback = new EventEmitter();
  @Output() selectBlock = new EventEmitter();
  statusTexts = STATUS_TEXTS;

  date = new Date();

  originInfoDropdown$ = new BehaviorSubject(false);
  destinationInfoDropdown$ = new BehaviorSubject(false);

  public readonly imageUrl = environment.assetsUrl;

  public readonly statuses = STATUSES;
  public readonly statusLane = [
    'pre_transit',
    'in_transit',
    'return_to_sender',
    'unsuccessful_delivery',
    'delivered'
  ];

  get detailsButtonStyles() {
    const { borderRadius, borderWidth, borderColor, backgroundColor, shadow } =
      this.detailsButton;
    return {
      'borderRadius.px': borderRadius,
      'borderWidth.px': borderWidth,
      borderColor,
      backgroundColor,
      boxShadow: shadow
    };
  }

  toggleInfoDropDown(key, value) {
    switch (key) {
      case 'origin': {
        return this.originInfoDropdown$.next(
          value || !this.originInfoDropdown$.value
        );
      }
      case 'destination': {
        return this.destinationInfoDropdown$.next(
          value || !this.destinationInfoDropdown$.value
        );
      }
    }
  }

  getCeilReview(data: { [key: string]: number }): number {
    if (data) {
      const dataValues = omit(data, [
        'comment',
        'totalScore',
        'shipmentId',
        'id'
      ]);
      const result =
        Math.floor(
          (Object.values(dataValues).reduce((acc, curr) => acc + curr) / 3) * 10
        ) / 10;
      return parseFloat(result === 0 ? '0.0' : result.toString());
    }
    return parseFloat('0.0');
  }

  selectCard(event, button, buttonText) {
    event.stopPropagation();
    if (isEqual(event.target, button) || isEqual(event.target, buttonText)) {
      this.selectBlock.emit('detailsButton');
    } else {
      this.selectBlock.emit('card');
    }
  }

  copyDescription(textarea) {
    copyTextToClipboard(textarea.value);
  }
}
